export default function PremiumStructure() {
  return (
    <section id="premium-structure" className="py-20 bg-gradient-to-br from-amber-50 via-rose-50 to-sky-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#8A2AE2]/10 text-[#5A2AE2] text-sm font-semibold rounded-full mb-4">
            PREMIUM STRUCTURE
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            합리적인 보험료 체계
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            케어인슈는 기존 보험의 구조적 문제를 해결하여 합리적인 보험료 체계를 제공합니다
          </p>
        </div>

        <div className="max-w-6xl mx-auto space-y-16">
          {/* 왜 보험료는 계속 오르기만 할까요? */}
          <div className="bg-white rounded-3xl p-12 shadow-xl">
            <h3 className="text-4xl font-bold text-gray-900 mb-12 text-center">
              왜 보험료는 계속 오르기만 할까요?
            </h3>
            
            <div className="grid md:grid-cols-2 gap-8">
              {/* 기존 보험의 구조적 문제 */}
              <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-6 md:p-8 border-2 border-red-200">
                <div className="bg-red-600 text-white text-center py-3 rounded-xl mb-6 text-lg md:text-xl font-bold">
                  기존 보험의 구조적 문제
                </div>
                
                <div className="space-y-4 mb-6">
                  <div className="flex items-start gap-3">
                    <div className="w-3 h-3 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-3">
                      <span className="text-sm md:text-base text-gray-800 font-medium">작위(직접적인 행위)에 의한 사고든</span>
                      <div className="flex gap-2">
                        <span className="px-3 py-1 bg-red-200 text-red-800 rounded-lg text-xs md:text-sm font-semibold">작위</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <div className="w-3 h-3 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-3">
                      <span className="text-sm md:text-base text-gray-800 font-medium">부작위(관리·감독 소홀)에 의한 사고든</span>
                      <div className="flex gap-2">
                        <span className="px-3 py-1 bg-red-200 text-red-800 rounded-lg text-xs md:text-sm font-semibold">부작위</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white rounded-xl p-4 md:p-6 mb-6">
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                    사고의 성격과 관계없이, <strong className="text-red-600">시설 과실이 없는 <br className="md:hidden" />자연 발생 사고 까지</strong> 모두 보험금이 지급되어 왔습니다.
                  </p>
                </div>
                
                <div className="space-y-3">
                  <div className="bg-red-100 rounded-lg p-4">
                    <p className="text-sm md:text-base text-gray-800 font-semibold mb-2">그 결과,</p>
                    <ul className="space-y-2 text-sm md:text-base text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-red-600 mt-0.5 flex-shrink-0"></i>
                        <span>전문인 배상 책임의 손해율만 비정상적으로 상승</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-red-600 mt-0.5 flex-shrink-0"></i>
                        <span>보험 구조는 시설소유자 2 : 전문인 8로 왜곡</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-red-600 mt-0.5 flex-shrink-0"></i>
                        <span className="font-bold text-red-600">결국 전체 보험료 인상으로 귀결</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 케어인슈의 합리적 구조 */}
              <div className="bg-gradient-to-br from-[#4A90E2]/10 to-[#4A90E2]/20 rounded-2xl p-6 md:p-8 border-2 border-[#4A90E2]/30">
                <div className="bg-[#4A90E2] text-white text-center py-3 rounded-xl mb-6 text-lg md:text-xl font-bold">
                  케어인슈의 합리적 구조
                </div>
                
                <div className="space-y-4 mb-6">
                  <div className="flex items-start gap-3">
                    <div className="w-3 h-3 bg-[#4A90E2] rounded-full mt-2 flex-shrink-0"></div>
                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-3">
                      <span className="text-sm md:text-base text-gray-800 font-medium">작위(직접적인 행위)에 의한 사고는</span>
                      <div className="flex gap-2">
                        <span className="px-3 py-1 bg-[#4A90E2]/20 text-[#2563EB] rounded-lg text-xs md:text-sm font-semibold">전문인 배상책임</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <div className="w-3 h-3 bg-[#4A90E2] rounded-full mt-2 flex-shrink-0"></div>
                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-3">
                      <span className="text-sm md:text-base text-gray-800 font-medium">부작위(관리·감독 소홀)에 의한 사고는</span>
                      <div className="flex gap-2">
                        <span className="px-3 py-1 bg-[#4A90E2]/20 text-[#2563EB] rounded-lg text-xs md:text-sm font-semibold">시설소유자 배상책임</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white rounded-xl p-4 md:p-6 mb-6">
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                    사고의 성격에 따라 <strong className="text-[#4A90E2]">책임을 명확히 구분</strong>하여,<br className="md:hidden" /> 각각의 보험에서 적절하게 보상합니다.
                  </p>
                </div>
                
                <div className="space-y-3">
                  <div className="bg-[#4A90E2]/10 rounded-lg p-4">
                    <p className="text-sm md:text-base text-gray-800 font-semibold mb-2">그 결과,</p>
                    <ul className="space-y-2 text-sm md:text-base text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-[#4A90E2] mt-0.5 flex-shrink-0"></i>
                        <span>전문인 배상책임의 손해율이 정상화</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-[#4A90E2] mt-0.5 flex-shrink-0"></i>
                        <span>보험 구조가 시설소유자 5 : 전문인 5로 균형</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-[#4A90E2] mt-0.5 flex-shrink-0"></i>
                        <span className="font-bold text-[#4A90E2]">합리적인 보험료로 안정적 운영 가능</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* 목표 구조 카드 - 별도 배치 */}
            <div className="mt-6 bg-emerald-600 text-white rounded-xl p-6">
              <div className="text-center text-2xl font-bold mb-4">케어인슈의 보험료 구조 목표</div>
              <div className="bg-white text-gray-800 rounded-lg p-6">
                <div className="flex items-start gap-3 mb-4">
                  <i className="ri-lightbulb-line text-3xl text-emerald-600 flex-shrink-0"></i>
                  <p className="font-bold">케어인슈는 전담 지정 손해사정사를 통해</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-emerald-50 rounded-lg p-5 border-2 border-emerald-200">
                    <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center mb-3 mx-auto">
                      <i className="ri-building-line text-white text-xl"></i>
                    </div>
                    <p className="text-center font-semibold text-gray-800">시설의 관리 책임<br />(부작위)</p>
                  </div>
                  <div className="bg-emerald-50 rounded-lg p-5 border-2 border-emerald-200">
                    <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center mb-3 mx-auto">
                      <i className="ri-user-heart-line text-white text-xl"></i>
                    </div>
                    <p className="text-center font-semibold text-gray-800">전문인의 직접 과실<br />(작위)</p>
                  </div>
                  <div className="bg-emerald-50 rounded-lg p-5 border-2 border-emerald-200">
                    <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center mb-3 mx-auto">
                      <i className="ri-leaf-line text-white text-xl"></i>
                    </div>
                    <p className="text-center font-semibold text-gray-800">자연 발생 사고<br />(순수)</p>
                  </div>
                </div>
                <p className="mt-4 text-center">
                  <strong>이 세 가지를 명확히 구분하여</strong>, 장기적으로 시설 5 : 전문인 5의 균형 잡힌 책임 구조를 지향합니다.<br />
                  이것이 보험료 거품을 제거하고 보험료를 낮추는 수 있는 가장 확실한 방법입니다.
                </p>
              </div>
            </div>
          </div>

          {/* 3. 보험료 안정화 효과 */}
          <div className="bg-gradient-to-br from-white to-emerald-50 rounded-3xl p-12 shadow-xl border-2 border-emerald-100">
            <div className="text-center mb-12">
              <h3 className="text-4xl font-bold text-gray-900 mb-8">케어인슈는 이렇게 다릅니다</h3>
              <p className="text-xl text-gray-700 leading-relaxed mb-4">
                보험료를 낮추는 것이 목적이 아닙니다.<br />
                <strong className="text-[#3B82F6]">보험료가 오르지 않는 구조</strong>를 만드는 것이 목적입니다.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-10 shadow-lg border-2 border-[#3B82F6]/20 text-center">
              <i className="ri-trophy-line text-6xl text-[#3B82F6] mb-6"></i>
              <p className="text-2xl font-bold text-gray-900 mb-6">
                요양시설 배상책임보험,<br />
                이제 기준이 바뀌어야 합니다.
              </p>
              <p className="text-2xl text-[#3B82F6] font-bold">
                케어인슈가 그 기준을 만듭니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
